<script>
  export default{
    props: ['mensagem'],
    name: 'chat-conversa-mensagem-propria',
    data () {
      return {}
    },
    computed: {},
    mounted () {},
    destroyed () {},
    methods: {},
    components: {}
  }
</script>

<template>
  <div class="mensagemPropria" :class="{'m-b': mensagem.showAvatar}">
    <p class="msg" :class="{startMessage: mensagem.startMessage, break: mensagem.showAvatar && !mensagem.startMessage, continue: !mensagem.showAvatar}">
      {{ mensagem.mensagem }}
      <!--<small class="text-muted">{{ mensagem.data.date | moment }}</small>-->
    </p>
  </div>
</template>

<style lang="scss">
  .mensagemPropria {
    display: flex;
    flex-direction: row-reverse;
    flex-wrap: wrap;
    line-height: 1.28;
    padding: 0 0 1px 0;
    text-align: initial;
    .msg{
      background: #4080ff;
      padding: 5px 8px 6px;
      color: #FFFFFF;
      max-width: 167px;
      word-wrap: break-word;
      border-radius: 20px 20px 0 20px;
      margin: 0;
      &.continue{
        border-radius: 20px 0 0 20px;
      }
      &.break{
        border-radius: 20px 0 20px 20px;
      }
      &.startMessage{
        border-radius: 20px 20px 0 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ChatConversaMensagemPropria.vue?bf1dcdde